import React from "react";
import Icon from "../../component/Icon";

import Jumbotron from "../../component/Jumbotron";
import Text from "../../component/Text";
import "./style.css";

const SkillPage: React.FC = () => (
  <Jumbotron
    flexDirection="column"
    justifyContent="center"
    textAlign="center"
    minHeight="100vh"
  >
    <Text text="SKILL" fs="60px" fontWeight="bold"/>
    <Jumbotron
      flexDirection="row"
      justifyContent="center"
      textAlign="left"
      height="90%"
      margin="100px auto"
      width="100%%"
    >
      <Icon onHoverText="HTML" altText="html" src="./skills/html5.svg"/>
      <Icon onHoverText="React" altText="react" src="./skills/react.svg"/>
      <Icon onHoverText="Redux" altText="redux" src="./skills/redux.svg"/>
      <Icon onHoverText="MQTT" altText="mqtt" src="./skills/mqtt.svg"/>
      <Icon onHoverText="Cypress" altText="cypress" src="./skills/cypress.svg"/>
      <Icon onHoverText="Jenkins" altText="jenkins" src="./skills/jenkins.svg"/>
      <Icon onHoverText="CSS" altText="css" src="./skills/css3.svg"/>
      <Icon onHoverText="Nodejs" altText="nodejs" src="./skills/nodejs.svg"/>
      <Icon onHoverText="Postgres" altText="postgres" src="./skills/postgresql2.svg"/>
      <Icon onHoverText="Graphql" altText="graphql" src="./skills/graphql.svg"/>
      <Icon onHoverText="Blender" altText="blender" src="./skills/blender.svg"/>
      <Icon onHoverText="Storybook" altText="storybook" src="./skills/storybook.svg"/>
    </Jumbotron>
  </Jumbotron>
);

export default SkillPage;
